@for (i of [1, 2, 3, 4, 5]; track $index) {
  <sd-icon
    type="star"
    [class]="'star ' + iconClass()"
    [class.star--active]="i <= displayedValue()"
    (mouseenter)="setValue(i)"
    (click)="saveValue(i)"
    (keydown.space)="saveValue(i)"
    [attr.tabindex]="disabled ? null : 0"
  ></sd-icon>
}
